import { Command } from '@/app/common/base/command'
import { OcktoFormState } from '@/app/inventory-form/entities/ockto-form-state.entity'

export class GetOcktoFormStateCommand extends Command {
    public async run(productActionId: string): Promise<OcktoFormState> {
        const response = await this.client.get(`/api/inventory-form/ockto-state/${productActionId}`)
        return response.asEntity(OcktoFormState)
    }
}
